export default class UrlHelpers{
    public static getLinkRelHref = (rel: string) : string => {
        let linkElements = document.head.getElementsByTagName("link");
        for (let i = 0; i < linkElements.length; i++) {
            if (linkElements[i].rel === rel) {
                return linkElements[i].href;
            }
        }
        return undefined;
    };
    public static getLocation = (href: string) : HTMLAnchorElement => {
        let a = document.createElement('a');
        a.href = href;
        return a;
    };
    public static getLinkDataDetails = (rel:string) : string => {
        let linkElements = document.head.getElementsByTagName("link");
        for (let i = 0; i < linkElements.length; i++) {
            if (linkElements[i].rel === rel) {
                return linkElements[i].dataset['details'];
            }
        }
        return undefined;
    };
    public static getMetaData = (key:string):string => {
        let metaElements = document.head.getElementsByTagName("meta");
        for (let i = 0; i < metaElements.length; i++) {
            if (metaElements[i].name === key) {
                return metaElements[i].content;
            }
        }
        return undefined;
    };
    public static setMetaData = (key:string, val:string):void => {
        let elements = document.head.getElementsByTagName('meta');
        for (let i = 0; i <elements.length; i++) {
            if (elements[i].name === key){
                elements[i].content = val;
                break;
            }
        }
    };
    public static getQueryParameter = (url_string:string, key:string):string => {
        if(url_string && key) {
            let url = new URL(url_string);
            return url.searchParams.get(key);
        }
        return undefined;
    };
    public static getSrcFromScript = (key:string):string => {
        let scriptElements = document.head.getElementsByTagName('script');
        for (let i = 0; i < scriptElements.length; i++) {
            if (scriptElements[i].title == key){
                return scriptElements[i].src;
            }
        }
        return undefined;
    };
    public static setQueryParameter = (url: string, key:string, value:string): string => {
        let uri = new URL(url);
        uri.searchParams.set(key, value);
        return uri.toString();
    };
    public static removeQueryParameter = (url: string, key:string): string => {
        let uri = new URL(url);
        uri.searchParams.delete(key);
        return uri.toString();
    }

    public static validateURL = (url: string):boolean => {
        const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return !!pattern.test(url);
    }
}